import sentry from 'legacy/utils/sentry'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ProposalRepository } from '../infra/ProposalRepository'

export type DownloadAttachmentsFactoryDependencies = {
  repository: ProposalRepository
}

export function downloadAttachmentsFactory({ repository }: DownloadAttachmentsFactoryDependencies) {
  return async function download(id: string, config?: { signal: AbortSignal }) {
    try {
      return await repository.downloadAttachments(id, config)
    } catch (error) {
      const customError = new Error('Failed to download attachments', { cause: error as Error })
      sentry.log(customError)
      throw customError
    }
  }
}

export function downloadAttachments(id: string, config?: { signal: AbortSignal }) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ProposalRepository({ httpClient })
  const download = downloadAttachmentsFactory({ repository })

  return download(id, config)
}
